export default class AuthApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(AuthApi.LoginPath);
    }

    login(username, password) {
        const formData = {
            username,
            password,
            grant_type: 'password'
        };

        return this.DashAPI.CORE.postFormData(AuthApi.LoginPath, formData);
    }
}

AuthApi.LoginPath = '/api/auth/token';



// WEBPACK FOOTER //
// ./src/DashApi/auth/AuthApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/auth/AuthApi.js